import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IAIAgentTemplate } from '../../extViewmodels/sdk/models/AI';

export const AI_AGENT_TEMPLATE_QUERY_KEY = 'aiAgentTemplateQuery';

export function useAIAgentTemplateQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!id,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `aiagenttemplate/${id}` }),
				'GET'
			);
		},
		queryKey: [AI_AGENT_TEMPLATE_QUERY_KEY, id],
	});
}
